export default "__VITE_ASSET__9106c829__"